import { useState } from 'react';

import isEqual from 'lodash/isEqual';

import { useCommentState } from '@gogame/components';

const useMarkState = ({ initialValue }) => {
  const [value, setValue] = useState(initialValue);
  const [error, setError] = useState(null);

  const handleChange = (_, v) => {
    setValue(v);
  };

  const handleClose = () => {
    setValue(initialValue);
  };

  return {
    field: {
      value: value,
      onChange: handleChange,
      error: error,
    },
    dirty: !isEqual(value, initialValue),
    close: handleClose,
    isValid: () => {
      if (!value) {
        if (!error) {
          setError('Rating is required');
        }
        return false;
      } else {
        if (error) {
          setError(null);
        }
        return true;
      }
    },
    onSetError: setError,
  };
};

export const useCommentWithMarkState = ({
  initialText = '',
  initialMark = null,
  onChange,
  onCancel,
}) => {
  const {
    field: markField,
    close: markClose,
    dirty: markDirty,
    isValid: isMarkValid,
    onSetError: setMarkError,
  } = useMarkState({
    initialValue: initialMark,
  });

  const {
    field: commentField,
    close: commentClose,
    dirty: textDirty,
    isValid: isTextValid,
    open,
    onSetError: setTextError,
  } = useCommentState({
    initialValue: initialText,
  });

  const handleSave = () => {
    if (isTextValid() && isMarkValid()) {
      onChange({
        comment: commentField?.value,
        mark: markField?.value,
      });
    }
  };

  const handleClose = () => {
    markClose();
    commentClose();
    setTextError(null);
    setMarkError(null);
    if (onCancel) {
      onCancel();
    }
  };

  return {
    commentField: commentField,
    markField: markField,
    onSave: handleSave,
    onCancel: handleClose,
    open: open,
    dirty: markDirty || textDirty,
    isTextValid: isTextValid,
    isMarkValid: isMarkValid,
  };
};
